import { render, staticRenderFns } from "./BackgroundBorder.vue?vue&type=template&id=e1f3c6d6&scoped=true&"
import script from "./BackgroundBorder.vue?vue&type=script&lang=js&"
export * from "./BackgroundBorder.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundBorder.vue?vue&type=style&index=0&id=e1f3c6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f3c6d6",
  null
  
)

export default component.exports